import {Types} from "../type/Types";
import {SearchConditionElement} from "./SearchConditionElement";
import {SortOrderElement} from "./SortOrderElement";
import {ErrorResponse, ResponseWrapper} from "./Response";

const json = require('json-bigint')({
    alwaysParseAsBig: false,
    useNativeBigInt: true
})

type HttpMethod = 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'GET'

async function _fetch(
    path: string,
    method: HttpMethod,
    body: any | undefined = undefined,
    requestInit: RequestInit | undefined = undefined
): Promise<Response> {
    return await fetch(`${process.env.REACT_APP_API_HOST}${path}`, {
        method: method,
        credentials: 'include',
        body: Types.asUndefined(body, json.stringify),
        ...requestInit,
    })
}

export namespace HttpClient {
    export function buildUrl<T>(
        path: string,
        searchConditions?: SearchConditionElement<T>[],
        sortOrders?: SortOrderElement<T>[],
        size?: number,
        offset?: bigint
    ): string {
        const arr: string[] = [
            searchConditions === undefined || searchConditions.length === 0 ? '' : SearchConditionElement.join(searchConditions),
            sortOrders === undefined || sortOrders.length === 0 ? '' : SortOrderElement.join(sortOrders),
            size === undefined ? '' : `size=${size}`,
            offset === undefined ? '' : `offset=${offset}`
        ].filter(v => v.length > 0)
        if (arr.length === 0) {
            return path
        } else {
            const url =  `${path + (path.toString().includes('campaigns/policies') ? '/' : '') + '?' + arr.join('&')}`
            console.log(url)
            return url
        }
    }

    export async function handleResponse<VO>(response: Response, construct: (o: any) => VO): Promise<VO> {
        const responseText = await response.text()
        const responseObject = json.parse(responseText)

        if (response.ok) {
            return ResponseWrapper.construct(responseObject, construct).result
        } else {
            return ResponseWrapper.construct(responseObject, ErrorResponse.construct).result.raise()
        }
    }
}

export const httpClient = {
    async post<VO>(
        path: string,
        body: any,
        construct: (o: any) => VO
    ): Promise<VO> {
        const response = await _fetch(path, 'POST', body, {
            headers: {
                'content-type': 'application/json'
            }
        })

        return HttpClient.handleResponse(response, construct)
    },
    async put<R>(
        path: string,
        body: any,
        construct: (o: any) => R
    ): Promise<R> {
        const response = await _fetch(path, 'PUT', body, {
            headers: {
                'content-type': 'application/json'
            }
        })

        return HttpClient.handleResponse(response, construct)
    },
    async patch<R>(
        path: string,
        body: any,
        construct: (o: any) => R
    ): Promise<R> {
        const response = await _fetch(path, 'PATCH', body, {
            headers: {
                'content-type': 'application/json'
            }
        })

        return HttpClient.handleResponse(response, construct)
    },
    async delete(
        path: string
    ): Promise<void> {
        const response = await _fetch(path, 'DELETE')

        console.log(response)
        console.log(path)

        return HttpClient.handleResponse(response, () => {})
    },
    async get<R>(
        path: string,
        construct: (o: any) => R
    ): Promise<R> {
        const response = await _fetch(path, 'GET')
        return HttpClient.handleResponse(response, construct)
    },

    async deleteIds(
        path: string,
        ids: any
    ): Promise<void> {

        const response = await _fetch(path, 'DELETE', {ids:ids}, {
            headers: {
                'content-type': 'application/json'
            }
        })

        return HttpClient.handleResponse(response, ()=>{})
    },
}